export const getEnvHostname = () =>
    window.location.hostname +
    (process.env.NODE_ENV === 'development' ? `:${window.location.port}` : '');
